"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M12,0 C18.627417,0 24,5.372583 24,12 C24,15.9319829 22.1088856,19.4222725 19.1865845,21.610941 C17.7641283,17.2032499 15.2846504,15 11.7479621,15 C8.23972375,15 5.88103622,17.1679455 4.67189951,21.5038364 C1.83056044,19.3094883 0,15.8685193 0,12 C0,5.372583 5.372583,0 12,0 Z M12,4 C9.790861,4 8,5.790861 8,8 C8,10.209139 9.790861,12 12,12 C14.209139,12 16,10.209139 16,8 C16,5.790861 14.209139,4 12,4 Z';